import React from "react";
import './CSS/Answer.css';
import img1 from "../Images/Gallery/Rectangle 3.png";
import img2 from "../Images/Gallery/Rectangle 4.png";
import img3 from "../Images/Gallery/Rectangle 5.png";
import img4 from "../Images/Gallery/Rectangle 6.png";
import img5 from "../Images/Gallery/Rectangle 7.png";

const Answer = () => {
  return (
    <section className="program-section">
      <h2 className="program-title"><span>पूर्व</span> कार्यक्रम</h2>

      <div className="main-content">
        <div className="text-area">
          <h3>‘गावकुसाबाहेर कविता’</h3>
          <p>स्थल: प्राचीन वडाचं मंदिर<br />
            विषय: "गावाचं कवितेत प्रतिबिंब"<br />
            दिनांक: १४ ऑगस्ट, २०२४</p>

          <p>
            'गावकुसाबाहेर कविता' हा संकल्पना केवळ भौगोलिक मर्यादा ओलांडण्याचा नाही, तर मानसिक 
            आणि सांस्कृतिक मोकळीक साधण्याचा एक प्रवास आहे. गावकुसा म्हणजे गावाची सीमारेषा – परंपरा, चालीरीती, 
            आणि एका विशिष्ट जीवनशैलीची चौकट. गावकुसात वाढलेली माणसं मातीचा गंध, नात्यांची ऊब, आणि साधेपणाचं मोल जपत 
            मोठी होतात. पण या कुशीतच राहून काही मनं अधिक स्वप्नाळू होतात – त्यांना फक्त आपला गावच नव्हे, तर 
            गावाच्या बाहेरचं विस्तीर्ण जगही बघायचं असतं. त्यांना जगायला, विचार करायला आणि स्वतःचा स्वतंत्र सूर लावायला 
            गावाच्या भिंती अपुऱ्या वाटू लागतात. अशा वेळेस ‘गावकुसाबाहेर कविता’ जन्मते. ही कविता गावच्या आठवणींची 
            गंधमाती बरोबर घेते, पण तिचा चेहरा नव्या दिशांकडे वळलेला असतो...
          </p>

          <h4>गावाचं कवितेत प्रतिबिंब :</h4>
          <p>
            "गावाचं कवितेत प्रतिबिंब" म्हणजे स्मरणरंजनही आहे आणि जिव्हाळ्याचा एक भावनापूर्ण दस्तऐवजही आहे. त्यातून 
            आपल्याला आपल्या मूळाशी जोडलेली माणुसकीची नाळ जाणवते आणि आयुष्याकडे पाहण्याची एक नितळ, 
            निर्मळ दृष्टिकोन मिळतो. गावाच्या साध्या, स्वच्छ, निसर्गाशी एकरूप जीवनाचा सुगंध कवितेतून दरवळतो, आणि वाचकाच्या
            मनातही त्या हरवलेल्या गंधांची, आठवणींची एक नवी वाट तयार होते. कवीच्या शब्दांतून गावाच्या रानावनाचा गंध येतो, पाखरांचं गाणं ऐकू येतं, 
            आणि वाड्यांमधून पसरणाऱ्या बोलक्या शांततेची चाहूल लागते.
          </p>

          <a href="#more" className="read-more">अधिक वाचा</a>
        </div>

        <div className="image-area">
          <img src={img1} alt="Village Scene" />
        </div>
      </div>

      <div className="gallery">
        {[
          {
            image: img2,
            title: "‘गावकुसाबाहेर कविता’",
           place: "प्राचीन वडाचं मंदिर ",
            topic: "गावाचं कवितेत प्रतिबिंब",
            details:"३० कवी,स्थानिक रसिक प्रेक्षक ",
            date: "१४ ऑगस्ट, २०२४",
            
          },
          {
            image:  img3,
            title: "‘श्रावण कविता मैफल’" ,
            place: "जिल्हा परिषद हॉल",
             topic: "पावसाच्या रात्री, मोकळ्या सभागृहात ",
              details: "३० कवी, स्थानिक रसिक प्रेक्षक",
              date:"१३ सप्टेंबर, २०२४",
          },
          {
            image: img4,
            title: "‘कविता आणि सामाजिक जाणीव’" ,
            place: "जिल्हा परिषद हॉल",
            topic: "स्त्रीवाद, पर्यावरण, लोकशाही विशेष",
            details: "कविता आणि क्रांती",
            date: "१० आँक्टोंबर, २०२४"
          },
          {
            image: img5,
            title:" ‘कवितेचं महाकुंभ’",
            place: "जिल्हा परिषद हॉल",
            topic: "५० जिल्ह्यांतील १०० कवी",
            details: "कवितांची छायाचित्रे + हस्ताक्षर संग्रह",
            date: "१८ नोव्हेंबर, २०२४",

          },
          
        ]
      
          
        .map((item, index) => (
          <div key={index} className="gallery-item">
            <img src={item.image} alt={item.title} />
            <h5>{item.title}</h5>
            <p><strong>{item.author}</strong></p>
            <p>{item.place}</p>
            <p>{item.topic}</p>
            <p>{item.details}</p>
            <p>{item.date}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Answer ;
